import * as constActions from './dashboardConstActionTypes';
import initialState from './initialState';

export default function dashboardReducer(state = initialState, action) {
  switch (action.type) {
    case constActions.GET_ALERTS_SUCCESS: {
      return Object.assign({}, state, {
        alerts: action.alerts
      });
    }
    case constActions.GET_ALERT_POINTS_SUCCESS: {
      return Object.assign({}, state, {
        alertRadarPoints: action.alertRadarPoints
      });
    }
    case constActions.GET_WL_STATISTICS_SUCCESS:
      return Object.assign({}, state, {
        wlStatistics: action.wlStatistics
      });
    case constActions.GET_HOSTS_STAT_SUCCESS:
      return Object.assign({}, state, {
        hostsStat: action.hostsStat
      });
    default:
      return state;
  }
}
